export class ImagingUnit {

    imagingUnitId: number;
    serialNumber: string;
    boardIdentifier: string;
    wiFiIpaddress: string;
    ethernetIpaddress: string;
    online: boolean;
    isActive: boolean;
    connectionId: string;
    isBusy: boolean;
    model: string;
    sampleTypeIds: number[];
    isLocalDevice = false;
    isBalenaOS: boolean;
    balenaUUID: string;
}

export interface IImagingUnit {
    boardIdentifier: string;
    imagingUnitId: number;
    isActive: boolean;
    serialNumber: string;
}

export class ImagingUnitCount {
    public model: string;
    public online: number = 0;
    public offline: number = 0;
}
